// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1d4126eb","977":"b93a6b32"}[chunkId] + ".chunk.js";
};